export interface GetActiveTrackStatusDto {
  RCN: string | number;
  StatusDetails: Status[];
}

export enum Status {
  Open = 'Open',
  RequestForReAllocation = 'Request For Re-Allocation',
  Assigned = 'Assigned',
  RequestCancellation = 'Request Cancellation',
  Pending = 'Pending',
  ResolvedSoftClosure = 'Resolved (soft closure)',
  Closed = 'Closed',
  Cancelled = 'Cancelled',
  Resolved = 'Resolved',
  NegativeResponseFromCustomer = 'Negative Response From Customer',
}

export interface StatusHistory {
  status_name: string;
  status_date: string;
  status_time: string;
}

export interface Ticket {
  ticketNo: string;
  status: Status;
  callType: string;
  serviceType: string;
  callBookDate: string;
  flag: string;
  product: string;
  rcn: string;
  model: string;
  serialNo: string;
  machineStatus: string;
  prd_image_url: string | null;
  status_reason: string;
  customer_voice: string | null;
  statusDetails?: any;
  prev_status?: string;
  statusHistory: StatusHistory[];
}

export interface ActiveRequest extends Ticket {}

export interface ClosedRequest extends Ticket {}

interface StatusDetail {
  date: string;
  time: string;
  title: string;
  description: string;
}

interface Details {
  content: string;
}

export interface SingleStatusData {
  id: string;
  status: string;
  serialNumber: string;
  complaintNumber: string;
  appliance: string;
  requestType: string;
  reportedOn: string;
  imageUrl: string;
  statusDetails: StatusDetail[];
  details: Details;
  inWarranty: boolean;
}

export interface EsclationReason {
  escalationCode: string;
  escalationName: string;
}

export interface EsclationStatus {
  ref_no: string;
  escalated_reasons: string;
  escalated_date: string;
}

export interface EsclationStatusResponse {
  data: EsclationStatus;
  status: 'true' | 'false';
}
